module.exports = __webpack_public_path__ + "static/cadastroRevezamento-f8701cdd8caeb6fe99f0903705d490d9.gif";